export default "__VITE_ASSET__GhUtUySl__"